export default __webpack_public_path__ + "3b75d75455f757d3f3a9db725b0be259.svg";